import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class ProductInfoController extends BasesController<any> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.business_busProductDetail,
      insert: EnumAPI.business_saveProduct,
      update: EnumAPI.business_updateProduct,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
      },
    });
  }
  /**
   * 查询商品
   * @param body
   * @returns
   */
  async onProductSearch(body) {
    const response: any = await AjaxBasics.request({
      ...EnumAPI.business_productSearch,
      body,
    });
    const product = lodash.find(response.productList, (item) => {
      return item.productId == body.productId;
    });
    return product;
  }
  /**
   * 搜索参数
   * @memberof ProductController
   */
  readonly SearchParams = new SearchParams({
    storageKey: 'product_info_search_params',
  });
  /**
   * 初始化搜索参数
   * @memberof ProductController
   */
  async initSearchParams() {
    if (lodash.has(this.SearchParams.value, 'Category')) {
      return;
    }
    const Category = await AjaxBasics.request(
      EnumAPI.business_queryProductClassify,
    );
    this.SearchParams.setSearchParams(Category);
  }

  /**
   * @des 提交产品
   */
  async onBusinessSubmit(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_submit,
      body,
    });
  }

  /**
   * @des 删除产品
   */
  async onDeleteProduct(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_deleteProduct,
      body,
    });
  }
  /**
   * @des 根据id获取产品信息详情
   */
  async onGetProductDetail(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_productDetail,
      body,
    });
  }
  /**
   * @des 获取二维码
   */
  async onSubscriptionBusBoV2(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_subscriptionBusBoV2,
      body,
      responseType: 'blob',
    });
  }
}

export class SearchParams extends BaseModel<{ Category: any }> {
  @computed
  get Category() {
    return this.value?.Category || [];
  }
  /**
   * @desc 转换 Category
   */
  formatCategory(Category) {
    const mapEnum = (item) => {
      const children = lodash.get(item, 'children', []);
      return {
        id: item.name,
        label: item.name,
        value: item.name,
        text: item.name,
        code: item.name,
        children: lodash.map(children, mapEnum),
      };
    };
    return lodash.map(Category, mapEnum);
  }
  setSearchParams(Category) {
    this.set({
      Category: this.formatCategory(Category),
    });
  }
}
